import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { stockService } from '../services/api'; // On importe ton service
import './ProductDetails.css';

const ProductDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);

    useEffect(() => {
        // On récupère les vraies données depuis PHP
        stockService.getProductById(id).then(data => {
            setProduct(data);
        });
    }, [id]);

    const handleUpdateStock = async (newQuantity) => {
        if (newQuantity < 0) return;
        const res = await stockService.updateStock(product.id, newQuantity);
        if (res.success) {
            setProduct({ ...product, stock_actuel: newQuantity });
        }
    };

    if (!product) return <div className="details-container"><p>Chargement du produit...</p></div>;

    return (
        <div className="details-container">
            <button className="btn-back" onClick={() => navigate(-1)}>← Retour Inventaire</button>

            <div className="product-card">
                <header className="product-header">
                    <h2>{product.designation}</h2>
                    <span className="ref-tag">Réf: {product.ref_produit}</span>
                    <br />
                    <span className="ref-tag" style={{ background: 'rgba(255,255,255,0.1)' }}>CB: {product.code_barre}</span>
                </header>

                <div className="product-grid">
                    <section className="info-section">
                        <h3>Informations</h3>
                        <p><strong>Catégorie:</strong> {product.categorie}</p>
                        <p><strong>Fournisseur:</strong> {product.fournisseur}</p>
                        <p><strong>Prix Achat:</strong> {product.prix_achat_ht} €</p>
                        <p><strong>Valeur Stock:</strong> {(product.prix_achat_ht * product.stock_actuel).toFixed(2)} €</p>
                    </section>

                    <section className="stock-section">
                        <h3>Gestion Stock</h3>
                        <div className={`stock-status ${product.stock_actuel <= product.stock_min ? 'critical' : 'good'}`}>
                            <span className="stock-number">{product.stock_actuel}</span>
                            <span className="stock-label">unités disponibles</span>
                        </div>

                        <div className="stock-actions">
                            <button className="btn-action" onClick={() => handleUpdateStock(parseInt(product.stock_actuel) + 1)}>
                                Réception (+)
                            </button>
                            <button className="btn-action btn-out" onClick={() => handleUpdateStock(parseInt(product.stock_actuel) - 1)}>
                                Sortie (-)
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;